<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BMKici/tc-custom/9781488067570.jpg?1740865053741" alt="This image is the cover for the book Conard County: Hard Proof, Conard County: The Next Generation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Conard County: Hard Proof, Conard County: The Next Generation
      </h1>
      <p class="bookDescription body article font2">
        <b>A deputy and a ghost hunter team up to uncover Conard County’s sinister secrets in a chilling romantic thriller from the <i>New York Times</i>–bestselling author.</b><br/><br/>Former soldier and newbie deputy Candela “Candy” Serrano is assigned as a liaison to Steve Hawks, the handsome host of TV’s <i>Ghostly Ties</i>. She’s skeptical of Steve’s purposes, since chasing supernatural shadows isn’t Candy’s idea of police work—until some very real killings start occurring around town. Suddenly, Candy and Steve find themselves struggling to track down who’s behind these vicious crimes . . . and how far they’ll go to keep long-buried secrets from surfacing.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Lee
      </h2>
      
      <p class="authorDescription body article">Rachel Lee was hooked on writing by the age of twelve and has lived all over the United States. This New York Times bestselling author now resides in Florida and writes full-time. Research is one of her favorite things.<Br><Br>Rachel loves her pets nearly as much as her four children. She has had both dogs and cats and is currently enjoying the antics of Jazz, her bloodhound. She also calls him her &quot;Gentle Giant.&quot;<Br><Br>&#160;<Br><Br>&#160;<Br><Br>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2aa181a2